/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  applicationUseCases: [],
  applicationLevels: [],
  // Tracks the most recently captured AI response history ID per channel.
  // Channels are kept separate so a text-channel AI suggestion isn't
  // overwritten when the user generates an AI email (and vice versa).
  aiResponseHistoryId: {
    text: null,
    email: null,
  },
};

const aiSlice = createSlice({
  name: "aiSlice",
  initialState,
  reducers: {
    setAiApplicationUseCases(state, action) {
      state.applicationUseCases = action.payload;
    },
    setApplicationLevels(state, action) {
      state.applicationLevels = action.payload;
    },
    setTextAiResponseHistoryId(state, action) {
      state.aiResponseHistoryId.text = action.payload ?? null;
    },
    setEmailAiResponseHistoryId(state, action) {
      state.aiResponseHistoryId.email = action.payload ?? null;
    },
    // Clears both channels in one shot. Useful when context becomes invalid
    // for any stored AI suggestion — e.g. switching to a different lead.
    resetAiResponseHistoryIds(state) {
      state.aiResponseHistoryId.text = null;
      state.aiResponseHistoryId.email = null;
    },
  },
});

export const {
  setAiApplicationUseCases,
  setApplicationLevels,
  setTextAiResponseHistoryId,
  setEmailAiResponseHistoryId,
  resetAiResponseHistoryIds,
} = aiSlice.actions;

// Per-channel selectors. Use these instead of reading state.aiData directly
// so the slice's internal shape can change without touching consumers.
export const getTextAiResponseHistoryId = state => state.aiData?.aiResponseHistoryId?.text ?? null;
export const getEmailAiResponseHistoryId = state =>
  state.aiData?.aiResponseHistoryId?.email ?? null;

export default aiSlice.reducer;
